import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Row, Col } from "styled-bootstrap-grid";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import { format } from "date-fns";
import { CloseO } from "styled-icons/evil/CloseO";
//import { Edit } from "styled-icons/material/Edit";
import ClickOutside from "react-simple-click-outside";
import { ChevronDown } from "styled-icons/boxicons-regular";
import Calendar from "../calendar.png";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu
} from "styled-dropdown-component";
import WeekPlannerForm from "../WeekPlanner/WeekPlannerForm";
import { InputText } from "../../../Shared/FormFields";
import DatePicker from "react-datepicker";
import { addWeekPlanner } from "../../../../Actions/WeekPlanner";
class WeekPlanner extends Component {
  constructor(props) {
    super(props);
    this.selectedDate = new Date();
    this.weekDayNames = [
      "week",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "Sunday"
    ];
    this.ref = React.createRef();
    this.state = {
      hiddenWeekNames: true,
      hiddenWeekPlanner: true,
      data: undefined,
      fullData: undefined,
      formDataOpen: false,
      editData: undefined,
      heightSet: 0,
      weekNr: props.weeklyPlanners
        ? props.weeklyPlanners.weekPlannerList[0].weekPlannerDetailsList[0]
            .weekNr
        : null
    };
  }

  changeView = () => {
    this.setState(state => {
      return {
        formDataOpen: !state.formDataOpen,
        editData: undefined
      };
    });
  };
  _close = target => {
    this.setState({
      [target]: true
    });
  };
  weekNameSelected = week => {
    let selectedWeek = week;
    this.setState({ selectedWeek });
  };
  handleOpenCloseDropdown = (name, data) => {
    if (name === "hiddenWeekNames") {
      this.setState({ weekNr: data });
    }
    this.setState(state => {
      return {
        [name]: !state[name]
      };
    });
  };

  handleDeleteClick = (dataArray, index) => {
    let data = this.state.data;
    data[index].isActive = "N";
    this.setState({ data });
    let payload = { branchNr: this.props.branchId, weeklyPlannerList: data };
    this.props.dispatch(addWeekPlanner(payload));
  };
  handleEditClick = (data, index) => {
    this.setState(state => {
      return { formDataOpen: !state.formDataOpen, editData: data };
    });
  };
  componentDidMount() {
    if (this.props.weeklyPlanners)
      this.setState(
        {
          data: this.props.height
            ? [this.props.weeklyPlanners.weekPlannerList[0]]
            : this.props.weeklyPlanners.weekPlannerList,
          fullData: this.props.weeklyPlanners.weekPlannerList
        },
        () => {
          if (this.props.height) {
            this.props.weekSelected(
              this.state.data[0].weekPlannerDetailsList[0]
            );
            this.props.weekPlannerView(this.state.data[0]);
          }
        }
      );
    //
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.data) {
        this.setState({ data: this.props.data, weekNr: this.props.weekNr });
      } else {
        if (this.props.weeklyPlanners) {
          this.setState({ data: this.props.weeklyPlanners.weekPlannerList });
        } else {
          this.setState({ data: undefined });
        }
      }
    }
  }

  render() {
    const {
      data,
      fullData,
      hiddenWeekPlanner,
      hiddenWeekNames,
      formDataOpen,
      editData,
      weekNr
    } = this.state;
    const {
      editanddelete,
      height,
      t,
      weekPlannerView,
      weekSelected,
      handleFormChange,
      comments
    } = this.props;
    return (
      <Wrapper maxHeight={height}>
        {data ? (
          data.map((weekData, index) => {
            return (
              <ParentDiv height={height} key={index}>
                {editanddelete ? (
                  <HeaderCol>
                    <HeaderLabel>{weekData.weekPlanName}</HeaderLabel>
                    <CLoseO
                      onClick={() => this.handleDeleteClick(weekData, index)}
                      size="20"
                    />
                    {/* <EDIT
                    onClick={() => this.handleEditClick(weekData, index)}
                    size="20"
                  /> */}
                  </HeaderCol>
                ) : (
                  <Cont>
                    <DropDownCol md={3}>
                      <DropDown>
                        <ClickOutside
                          close={this._close}
                          target="hiddenWeekPlanner"
                        >
                          <div
                            onClick={() =>
                              this.handleOpenCloseDropdown("hiddenWeekPlanner")
                            }
                          >
                            {weekData.weekPlanName} <Chevrondown size="20" />
                          </div>

                          <DropDownMenu hidden={hiddenWeekPlanner}>
                            {fullData.map((data, index) => (
                              <DropdownItem
                                onClick={() => {
                                  weekPlannerView(data);
                                  this.handleOpenCloseDropdown(
                                    "hiddenWeekPlanner"
                                  );
                                }}
                                key={index}
                              >
                                <Trans>{data.weekPlanName}</Trans>
                              </DropdownItem>
                            ))}
                          </DropDownMenu>
                        </ClickOutside>
                      </DropDown>
                    </DropDownCol>
                    <DropDownCol md={3}>
                      <label>
                        <Trans>startFromWeek</Trans>
                      </label>
                      <DropDownWeek>
                        <ClickOutside
                          close={this._close}
                          target="hiddenWeekNames"
                        >
                          <div
                            onClick={() =>
                              this.handleOpenCloseDropdown(
                                "hiddenWeekNames",
                                weekNr
                              )
                            }
                          >
                            {weekNr
                              ? weekNr
                              : weekData.weekPlannerDetailsList[0].weekNr}{" "}
                            <Chevrondown size="20" />
                          </div>

                          <DropDownMenu hidden={hiddenWeekNames}>
                            {weekData.weekPlannerDetailsList.map(
                              (weekNameData, index) => (
                                <DropdownItem
                                  onClick={() => {
                                    this.handleOpenCloseDropdown(
                                      "hiddenWeekNames",
                                      weekNameData.weekNr
                                    );

                                    weekSelected(weekNameData.weekNr);
                                  }}
                                  key={index}
                                >
                                  {weekNameData.weekNr}
                                </DropdownItem>
                              )
                            )}
                          </DropDownMenu>
                        </ClickOutside>
                      </DropDownWeek>
                    </DropDownCol>
                    <DropDownCol md={2}>
                      <Span>
                        <Trans>endRepeat</Trans>
                      </Span>
                      <DatePickerDiv
                        customInput={
                          <div className="DateValue">
                            {" "}
                            {format(this.selectedDate, "d MMM yyyy")}{" "}
                          </div>
                        }
                        dateFormat="d MMM yyyy"
                        selected={this.selectedDate}
                        onChange={data => {
                          this.selectedDate = data;
                          handleFormChange(data, "repeatEndDate");
                        }}
                        minDate={this.selectedDate}
                      />
                      <ImageSpan>
                        <Img src={Calendar} alt="Calendar" />
                      </ImageSpan>
                    </DropDownCol>
                    <DropDownCol md={4}>
                      <InputText
                        label={t("comments")}
                        name="comments"
                        value={comments}
                        color={true}
                        editMode={true}
                        handleChange={e =>
                          handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </DropDownCol>
                  </Cont>
                )}
                <WeekDataDiv>
                  <ROW>
                    {this.weekDayNames.map(days => {
                      return (
                        <COL className="WeekDayName" key={days} sm="2">
                          <Trans>{days}</Trans>
                        </COL>
                      );
                    })}
                  </ROW>
                  <WeekPlanDataDetails>
                    {weekData.weekPlannerDetailsList.map((data, index) => {
                      return (
                        <ROW key={index}>
                          {" "}
                          <COL sm="2">{data.weekNr}</COL>
                          {data.weekPlannerDataList.map((data, index) => {
                            return (
                              <DataCol key={index} sm="2">
                                {data.shiftTimings}{" "}
                              </DataCol>
                            );
                          })}
                        </ROW>
                      );
                    })}
                  </WeekPlanDataDetails>
                </WeekDataDiv>
              </ParentDiv>
            );
          })
        ) : (
          <div />
        )}

        {editanddelete && (
          <FooterData ref={this.ref} formDataOpen={formDataOpen}>
            {!formDataOpen ? (
              <p>
                <Button onClick={this.props.BackTab}>
                  <Trans>back</Trans>
                </Button>
                <Button onClick={this.changeView}>
                  <Trans>addNewPlan</Trans>
                </Button>
              </p>
            ) : (
              <WeekPlannerForm
                editData={editData}
                handleClose={this.changeView}
              />
            )}
          </FooterData>
        )}
      </Wrapper>
    );
  }
}
const mapStateToProps = ({ auth, userMessage, managerTimesheetData }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    weeklyPlanners: managerTimesheetData.payload.weeklyPlanners,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    userData: auth.user.defaultProfile
  };
};
export default withRouter(
  connect(mapStateToProps)(withTranslation()(WeekPlanner))
);
const DropDownCol = styled(Col)`
  text-align: left;
`;
const WeekPlanDataDetails = styled.div`
  max-height: 36.1vh;
  overflow-y: auto;
`;
const DatePickerDiv = styled(DatePicker)`
  background: #f1f4f9;
  padding-left: 3% !important;
  border: 1px solid #707070;
  font-size: 13px;
  text-align: left;
  width: 120px;
  height: 28px;
  padding: 5px 10px 5px;
`;
const ImageSpan = styled.div`
  position: relative;
  left: 96px;
  bottom: 25px;
`;
const Img = styled.img`
  height: 15px;
`;
const Span = styled.div`
  padding-bottom: 4px;
  padding-left: 1px;
  font-size: 13px;
`;
const ParentDiv = styled.div` 
  background-color: #f1f4f9;
  position: relative;
  padding-top:${props => (props.height ? "0%" : "20px")};;
  margin-top: ${props => (props.height ? "0%" : "40px")};
  display:grid
  padding-bottom:1%
  border-radius : 4px
  padding-left: 11px;
  padding-right: 11px;
  border: ${props => (props.height ? "0" : "1px solid #E1E5EB")}; `;
const CLoseO = styled(CloseO)`
  float :right
  position: relative;
  right: 2%;
  color: #a4a4a5;
  cursor:pointer`;
const HeaderCol = styled(Row)`
  margin-right: 0px;
  margin-left: 0px;
  display: block;
`;
const Cont = styled.div`
  display: flex;
`;
const DropDownMenu = styled(DropdownMenu)`
  overflow-y: scroll;
  max-height: 100px;
`;
const HeaderLabel = styled.label`
  float : left
  padding-left: 2%;
  margin-bottom: 0.75rem;`;
const Wrapper = styled.div`
  font-size :16px
  font-family:Trebuchet MS;
  && label {font-size :16px
  font-family:Trebuchet MS;}
  padding: ${props => (props.height ? "0 0 0 0" : "0% 9% 0% 8%")};
//max-height: ${props => (props.maxHeight ? props.maxHeight : "auto")};
  overflow :${props => (props.maxHeight ? "none" : "auto")};
  height:${props => (props.maxHeight ? "auto" : "calc(100vh - 210px)")}
`;
// const EDIT = styled(Edit)`
//   color: #a4a4a5;
//   float :right
//   right:4%
//   position: relative
//   cursor:pointer`;
const WeekDataDiv = styled.div`
  border: 0.5px solid #babec3;
  border-radius: 4px 4px 0px 0px;
  padding: 1px;
`;
const ROW = styled(Row)`
  margin-right: 0px;
  margin-left: 0px;
  font-size: 16px;
  border-radius: 2px;
  background: #e1e5eb;
  border-bottom: 1px;
  && .WeekDayName {height : 35px
    padding-top: 0.75%;
  }
`;
const COL = styled(Col)`
  background: #e1e5eb
  max-width: 12.5% !important;
  padding-right: 0px; 
  padding-left: 0px;
  font-weight: 550;
  padding-top: 1.5%;
  border: 1px solid #e8e8e8;
`;
const DataCol = styled(Col)`
  max-width: 12.5% !important;
  padding-right: 0px;
  padding-left: 0px;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  padding-top: 1.5%;
`;
const DropDown = styled(Dropdown)`
  position : relative
  top:36%
  border-bottom: 1px solid #b2b7be;`;
const DropDownWeek = styled(Dropdown)`
  position : relative
  bottom: 6px;
  border-bottom: 1px solid #b2b7be;`;
const Chevrondown = styled(ChevronDown)`
  position: absolute;
  left: 93%;
`;
const Button = styled.button`
  background: #fff;
  border-radius: 30px;
  margin: 0 5px;
  padding: 0;
  border: 1px solid #babec3;
  height: 38px;
  width: 129px;
  font-weight: 50;
  position: relative;
  left: 8px;
  color: #000;
  font-size: 12px;
`;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  text-align: center;
  position:fixed
  bottom:0px
  right: 0px;
  width: 101%;
  margin-left: 4px;
  && p {
    bottom: 0px;
    position: absolute;
    width: 100%;
  }
  ${({ formDataOpen }) =>
    formDataOpen &&
    `
  height: 315px
  `}
`;
